import React from 'react';
import { connect } from 'react-redux';
import '../../styles/components.css';
import translationL from '../language/translation.js';
import LocalizedStrings from 'react-localization';
import agent from '../../agent'
const mapStateToProps = state => (
	Object.assign({}, state, {
		language_key: state.common.language_key,
	})
);

const mapDispatchToProps = dispatch => ({
});
let sTranslationL = new LocalizedStrings(translationL);
class SchoolSetupMenu extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			menu_active: "",
			userSettings: [],
			userRole: 0,
			language: 'en',
		}
		this.showModalEror = (message) => {
			this.setState({ isOpenModal: true, msg: message })
		}
		this.get_configuration = () => {
			agent.admin.get_configuration({}).then(datas => {
				//console.log(datas)
				if (datas.status === true) {
					let data = datas.data;
					if (!data) return;
					let user_settings = data.user_settings;
					this.setState({
						userSettings: user_settings,
					})
				}
			})
		}
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps && nextProps.language_key) {
			this.setState({ language: nextProps.language_key });
		}
	}
	componentDidMount() {
		this.setState({ menu_active: this.props.menu })
		this.get_configuration();
		let language = window.localStorage.getItem('language');
		if (language != undefined && language != null && language != '') {
			this.setState({ language: language });
		}
		let userSettings = window.localStorage.getItem('user_settings');
		userSettings = JSON.parse(userSettings);
		let role_login = window.localStorage.getItem('last_role');
		let USERLOG = (parseInt(role_login) === 1) ? 'USERLOGSUP' : 'USERLOG';
		//let userInfo = window.localStorage.getItem('USERLOG');
		let userInfo = window.localStorage.getItem(USERLOG);

		// console.log(userInfo);
		if (userInfo !== undefined && userInfo !== '') {
			userInfo = JSON.parse(userInfo);
			let userRole = userInfo.last_role;
			this.setState({
				// userSettings: userSettings,
				userRole: userRole,
			})
		}
	}

	render() {
		let userSettings = this.state.userSettings;
		let language = (this.state.language != undefined && this.state.language != null && this.state.language != '') ? this.state.language : 'en';
		sTranslationL.setLanguage(language);
		let hosts = window.location.hostname
		hosts = hosts.split(".")
		let hostis = (hosts !== undefined && hosts !== null && hosts[0] !== undefined) ? hosts[0] : '';
		
			return (
				<div className="" style={{ width: '100%' }}>
					<div className="school-setup-menu-wrapper">
						<div className="school-setup-menu-header py-2">{sTranslationL.school}</div>
						{/* {(userSettings.updateschoolinformation || userSettings.saeditschool) && */}
						{((this.state.userRole == 2 && (userSettings.updateschoolinformation || userSettings.saeditschool)) || (this.state.userRole == 1 && (userSettings.saeditschool == true || userSettings.saupdateschoolinformation == true))) &&
							<div className="school-setup-menu">
								<a href="/school-information" className={`school-setup-menu-link ${this.state.menu_active == 'school-information' ? 'active' : ''}`}>{sTranslationL.school_information}</a>
							</div>
						}
						{/* } */}
						{((this.state.userRole == 2 && (userSettings.viewmiscschoolconfiguration || userSettings.updatemiscschoolconfiguration)) || (this.state.userRole == 1 && (userSettings.saviewmiscschoolconfiguration || userSettings.saupdatemiscschoolconfiguration))) &&
							<div className="school-setup-menu">
								<a href="/school-misc-config" className={`school-setup-menu-link ${this.state.menu_active == 'school-misc-config' ? 'active' : ''}`}>{sTranslationL.school_misc_configuration}</a>
							</div>
						}
						{/* {(this.state.userRole == 1) &&
						<div className="school-setup-menu">
							<a href="/feature-access-architecture" className={`school-setup-menu-link ${this.state.menu_active == 'feature-access-architecture' ? 'active' : ''}`}>School Group Based Tags</a>
						</div>
						} */}
						{((this.state.userRole == 2 && (userSettings.readschooltags == true || userSettings.editschooltags == true)) || (this.state.userRole == 1 && (userSettings.sareadschooltags == true || userSettings.saeditschooltags == true))) &&
							<div className="school-setup-menu">
								<a href="/school-tags" className={`school-setup-menu-link ${this.state.menu_active == 'school-tags' ? 'active' : ''}`}>{sTranslationL.school_tags}</a>
							</div>
						}
						{(this.state.userRole == 2 && userSettings.updateroletags == true) &&
							<div className="school-setup-menu">
								<a href="/school-based-tags" className={`school-setup-menu-link ${this.state.menu_active == 'school-based-tags' ? 'active' : ''}`}>{sTranslationL.role_tags}</a>
							</div>
						}
						{(this.state.userRole == 1 && (userSettings.saviewcontentintegration == true || userSettings.saupdatecontentintegration == true)) &&
							<div className="school-setup-menu">
								<a href="/content-integration" className={`school-setup-menu-link ${this.state.menu_active == 'content-integration' ? 'active' : ''}`}>{sTranslationL.content_integration}</a>
							</div>
						}
						{(this.state.userRole == 1 && (userSettings.saupdateuserroles == true)) &&
							<div className="school-setup-menu">
								<a href="/user-roles" className={`school-setup-menu-link ${this.state.menu_active == 'user-roles' ? 'active' : ''}`}>{sTranslationL.user_roles}</a>
							</div>
						}
						{((this.state.userRole == 2 && userSettings.updatecommunicationuserrules) || (this.state.userRole == 1 && userSettings.saupdatecommunicationuserrules)) &&
							<div className="school-setup-menu">
								<a href="/communication-user-rules" className={`school-setup-menu-link ${this.state.menu_active == 'communication-user-rules' ? 'active' : ''}`}>{sTranslationL.communication_user_rules}</a>
							</div>
						}
						{((this.state.userRole == 2 && (userSettings.createschooladmin || userSettings.updateschooladmin || userSettings.addschooladmin)) || (this.state.userRole == 1 && (userSettings.sacreateschooladmin || userSettings.saupdateschooladmin))) &&
							<div className="school-setup-menu">
								<a href="/school-admins" className={`school-setup-menu-link ${this.state.menu_active == 'school-admins' ? 'active' : ''}`}>{sTranslationL.school_administrators}</a>
							</div>
						}
						{((this.state.userRole == 2 && (userSettings.updateschoolyearconfiguration || userSettings.readschoolyearconfiguration)) || (this.state.userRole == 1 && (userSettings.saupdateschoolyearconfiguration || userSettings.sareadschoolyearconfiguration))) &&
							<div className="school-setup-menu">
								<a href="/school-config" className={`school-setup-menu-link ${this.state.menu_active == 'school-config' ? 'active' : ''}`}>{sTranslationL.school_year_configuration}</a>
							</div>
						}
						{((this.state.userRole == 2 && (userSettings.viewaccountreceivable || userSettings.manageaccountreceivable)) || (this.state.userRole == 1 && (userSettings.saviewaccountreceivable || userSettings.samanageaccountreceivable))) &&
							<div className="school-setup-menu">
								<a href="/ar-payment-config" className={`school-setup-menu-link ${this.state.menu_active == 'ar-payment-config' ? 'active' : ''}`}>{sTranslationL.A_R_payment_configuration}</a>
							</div>
						}
						{((this.state.userRole == 2 && (userSettings.updateadditionalfields || userSettings.createadditionalfields)) || (this.state.userRole == 1 && (userSettings.saupdateadditionalfields || userSettings.sacreateadditionalfields))) &&
							<div className="school-setup-menu">
								<a href="/additional-field" className={`school-setup-menu-link ${this.state.menu_active == 'additional-field' ? 'active' : ''}`}>{sTranslationL.additional_fields}</a>
							</div>
						}
						{((this.state.userRole == 2 && (userSettings.updatefacility || userSettings.readfacility)) || (this.state.userRole == 1 && (userSettings.sareadfacility || userSettings.saupdatefacility))) &&
							<div className="school-setup-menu">
								<a href="/facility-management" className={`school-setup-menu-link ${this.state.menu_active == 'facility-management' ? 'active' : ''}`}>{sTranslationL.facility}</a>
							</div>
						}
						{((this.state.userRole == 2 && (userSettings.updateenrollmentrules || userSettings.readenrollmentrules)) || (this.state.userRole == 1 && (userSettings.saupdateenrollmentrules || userSettings.sareadenrollmentrules))) &&
							<div className="school-setup-menu">
								<a href="/enrollment-rule" className={`school-setup-menu-link ${this.state.menu_active == 'enrollment-rule' ? 'active' : ''}`}>{sTranslationL.enrollment_rules}</a>
							</div>
						}
						{((this.state.userRole == 2 && (userSettings.updatestudentcontractrules || userSettings.readstudentcontractrules || userSettings.createstudentcontractrules)) || (this.state.userRole == 1 && (userSettings.saupdatestudentcontractrules || userSettings.sareadstudentcontractrules))) &&
							<div className="school-setup-menu">
								<a href="/student-contract-rules" className={`school-setup-menu-link ${this.state.menu_active == 'student-contract-rules' ? 'active' : ''}`}>{sTranslationL.student_contract_rules}</a>
							</div>
						}
						{((this.state.userRole == 2 && (userSettings.updateproducts || userSettings.readproducts)) || (this.state.userRole == 1 && (userSettings.saupdateproducts || userSettings.sareadproducts))) &&
							<div className="school-setup-menu">
								<a href="/products" className={`school-setup-menu-link ${this.state.menu_active == 'products' ? 'active' : ''}`}>{sTranslationL.products}</a>
							</div>
						}
						{((this.state.userRole == 2 && (userSettings.updatenotificationtemplate)) || (this.state.userRole == 1 && (userSettings.saupdatenotificationtemplate))) &&
							<div className="school-setup-menu" style={{ 'display': 'none' }}>
								<a href="/notification-templates" className={`school-setup-menu-link ${this.state.menu_active == 'notification-templates' ? 'active' : ''}`}>{sTranslationL.notification_templates}</a>
							</div>
						}
						{((this.state.userRole == 2 && (userSettings.viewnotificationrules == true || userSettings.updatenotificationrules == true)) || (this.state.userRole == 1 && (userSettings.saviewnotificationrules == true || userSettings.saupdatenotificationrules == true))) &&
							<div className="school-setup-menu">
								<a href="/notification-rule-template" className={`school-setup-menu-link ${this.state.menu_active == 'notification-rule-template' ? 'active' : ''}`}>Notification Rules</a>
							</div>
						}
						{((this.state.userRole == 1 && (userSettings.saviewtranscriptvieweroptions == true || userSettings.saupdatetranscriptvieweroptions == true)) || (this.state.userRole == 2 && (userSettings.readtranscriptvieweroptions == true || userSettings.updatetranscriptvieweroptions == true))) &&
							<div className="school-setup-menu">
								<a href="/transcript-viewer-options" className={`school-setup-menu-link ${this.state.menu_active == 'transcript-viewer-options' ? 'active' : ''}`}>{sTranslationL.transcript_viewer_options}</a>
							</div>
						}
						{(this.state.userRole == 1 && (userSettings.saviewfeatureconfiguration == true || userSettings.saupdatefeatureconfiguration == true)) &&
							<div className="school-setup-menu">
								<a href="/feature-config" className={`school-setup-menu-link ${this.state.menu_active == 'feature-config' ? 'active' : ''}`}>{sTranslationL.feature_configuration}</a>
							</div>
						}
						{(this.state.userRole == 1 && (userSettings.saviewfeaturesetting == true || userSettings.saupdatefeaturesetting == true)) &&
							<div className="school-setup-menu">
								<a href="/feature-settings" className={`school-setup-menu-link ${this.state.menu_active == 'feature-settings' ? 'active' : ''}`}>{sTranslationL.feature_settings}</a>
							</div>
						}
						{(this.state.userRole == 1 && (userSettings.saviewcommunicationrules == true || userSettings.saupdatecommunicationrules == true)) &&
							<div className="school-setup-menu">
								<a href="/communication-rules" className={`school-setup-menu-link ${this.state.menu_active == 'communication-rules' ? 'active' : ''}`}>{sTranslationL.communication_rules}</a>
							</div>
						}
						{((this.state.userRole == 1 || this.state.userRole == 2) && (userSettings.saviewstatus == true || userSettings.saupdatestatus == true)) &&
							<div className="school-setup-menu">
								<a href="/status" className={`school-setup-menu-link ${this.state.menu_active == 'status' ? 'active' : ''}`}>{sTranslationL.status}</a>
							</div>
						}
						{((this.state.userRole == 1 || this.state.userRole == 2) && (userSettings.saviewobjectstate == true || userSettings.saupdateobjectstate == true)) &&
							<div className="school-setup-menu">
								<a href="/object-state" className={`school-setup-menu-link ${this.state.menu_active == 'object-state' ? 'active' : ''}`}>{sTranslationL.object_state}</a>
							</div>
						}
						{((this.state.userRole == 1 && (userSettings.saviewcommentsanddocument == true || userSettings.saupdatecommentsanddocument == true || userSettings.adlsadmin)) || (this.state.userRole == 2 && (userSettings.saviewschoolcomment || userSettings.saaddschoolcomment || userSettings.adlsadmin))) &&
							<div className="school-setup-menu">
								<a href="/school-comment" className={`school-setup-menu-link ${this.state.menu_active == 'school-comment' ? 'active' : ''}`}>School Comments & Documents</a>
							</div>
						}

						<div className="school-setup-menu-header py-2">{sTranslationL.academic_system}</div>
						{((this.state.userRole == 1 && (userSettings.sareaddepartments == true || userSettings.saupdatedepartment == true)) || (this.state.userRole == 2 && (userSettings.updatedepartments || userSettings.readdepartments))) &&
							<div className="school-setup-menu">
								<a href="/departments" className={`school-setup-menu-link ${this.state.menu_active == 'departments' ? 'active' : ''}`}>{sTranslationL.departments}</a>
							</div>
						}
						{((this.state.userRole == 1 && (userSettings.sareadgradingscales == true || userSettings.saupdategradingscales == true)) || (this.state.userRole == 2 && (userSettings.updategradingscales || userSettings.creategradingscales || userSettings.readgradingscales))) &&
							<div className="school-setup-menu">
								<a href="/grading-scales" className={`school-setup-menu-link ${this.state.menu_active == 'grading-scales' ? 'active' : ''}`}>{sTranslationL.grading_scales}</a>
							</div>
						}
						{((this.state.userRole == 1 && (userSettings.sareadbellschedules == true || userSettings.saupdatebellschedule == true)) || (this.state.userRole == 2 && (userSettings.readbellschedules || userSettings.updatebellschedules))) &&
							<div className="school-setup-menu">
								<a href="/bell-schedule" className={`school-setup-menu-link ${this.state.menu_active == 'bell-schedule' ? 'active' : ''}`}>{sTranslationL.bell_Schedule}</a>
							</div>
						}
						{((this.state.userRole == 1 && (userSettings.sareadgradingperiods == true || userSettings.saupdategradingperiods == true)) || (this.state.userRole == 2 && (userSettings.readgradingperiods || userSettings.updategradingperiods))) &&
							<div className="school-setup-menu">
								<a href="/grading-periods" className={`school-setup-menu-link ${this.state.menu_active == 'grading-periods' ? 'active' : ''}`}>{sTranslationL.grading_periods}</a>
							</div>
						}
						{((this.state.userRole == 1 && (userSettings.sareadacademictracks == true || userSettings.saupdateacademictracks == true)) || (this.state.userRole == 2 && (userSettings.createacademictracks || userSettings.updateacademictracks || userSettings.readacademictracks))) &&
							<div className="school-setup-menu">
								<a href="/academic-tracks" className={`school-setup-menu-link ${this.state.menu_active == 'academic-tracks' ? 'active' : ''}`}>{sTranslationL.academic_tracks}</a>
							</div>
						}
						{((this.state.userRole == 1 && (userSettings.sareadlearningpathtemplates == true || userSettings.saupdatelearningpathtemplates == true)) || (this.state.userRole == 2 && (userSettings.updatelearningpathtemplates || userSettings.readlearningpathtemplates))) &&
							<div className="school-setup-menu">
								<a href="/ilp" className={`school-setup-menu-link ${this.state.menu_active == 'ilp' ? 'active' : ''}`}>{sTranslationL.learning_path_templates}</a>
							</div>
						}
						{((this.state.userRole == 1 && (userSettings.sareadgradebookactivitydescriptions == true || userSettings.saupdategradebookactivitydescriptions == true)) || (this.state.userRole == 2 && (userSettings.updategradebookactivitydescriptions || userSettings.creategradebookactivitydescriptions))) &&
							<div className="school-setup-menu">
								<a href="/gradebook-activity-descriptions" className={`school-setup-menu-link ${this.state.menu_active == 'gradebook-activity-descriptions' ? 'active' : ''}`}>{sTranslationL.grade_book_activity_descriptions}</a>
							</div>
						}
						{((this.state.userRole == 1 && (userSettings.sareadacademicterms == true || userSettings.saupdateacademicterms == true)) || (this.state.userRole == 2 && (userSettings.createacademicterms || userSettings.updateacademicterms || userSettings.readacademicterms))) &&
							<div className="school-setup-menu">
								<a href="/academic-terms" className={`school-setup-menu-link ${this.state.menu_active == 'academic-terms' ? 'active' : ''}`}>{sTranslationL.academic_terms}</a>
							</div>
						}
					</div>
				</div>
			);
		
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(SchoolSetupMenu)